module.exports = __webpack_public_path__ + "static/media/nid_card.f4432021.png";